import { Button as MuiButton, Tooltip } from '@mui/material';
import React, { ReactNode } from 'react';

interface IProps {
  onClick?: () => void;
  label?: string;
  type?: 'button' | 'submit' | 'reset' | undefined;
  disabled?: boolean;
  onKeyDown?: (e: React.KeyboardEvent) => void;
  children?: React.ReactNode;
  size?: 'small' | 'medium' | undefined;
  style?: React.CSSProperties;
  id?: string;
  className?: string;
  startIcon?: ReactNode;
  endIcon?: ReactNode;
  [key: string]: any;
  tooltip?: string | null;
}

const Button: React.FC<IProps> = ({
  label,
  onClick,
  type = 'button',
  disabled,
  children = undefined,
  size,
  style,
  id,
  className,
  startIcon,
  endIcon,
  tooltip,
  ...rest
}) => {
  const button = (
    <MuiButton
      onClick={onClick}
      variant="contained"
      type={type}
      disabled={disabled}
      size={size}
      style={style}
      id={id}
      className={className}
      startIcon={startIcon}
      endIcon={endIcon}
      {...rest}
    >
      {children ?? label}
    </MuiButton>
  );
  return tooltip ? (
    <Tooltip title={tooltip} arrow>
      <span>{button}</span>
    </Tooltip>
  )
    : button;
};

export default Button;
